<template>
  <a-form-model ref="form" :model="form.data" :rules="form.rules">
    <a-form-model-item label="选择支付方式" required >
      <a-radio-group v-model="payment" @change="toPayInfo">
        <a-radio value="ali-pay">ali-pay</a-radio>
        <a-radio value="wx-pay">wx-pay</a-radio>
        <a-radio value="third-pay">third-pay</a-radio>
      </a-radio-group>
    </a-form-model-item>
    <a-form-model-item label="生成的支付链接"  >
      <a-input v-model="form.data.payUrl"></a-input>
    </a-form-model-item>
    <a-form-model-item>
     <a-space>
<!--       <a-button type="primary" v-if="!orderId" @click="onAdd">创建</a-button>-->
       <a-button @click="onCancel">{{ $t('CANCEL') || '取消' }}</a-button>
     </a-space>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import {
  _toAliPay,
  _toWxPay,
} from '@/api/websiteOrderApi';

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

function toPayInfo(e) {
  const payment = e.target.value;
  // 生成相应的支付链接或图片
  if (payment === 'ali-pay') {
    const result = _toAliPay(this.orderId);
    console.log(result);
  } else if (payment === 'wx-pay') {
    const result = _toWxPay(this.orderId);
    console.log(result);
  } else if (payment === 'third-pay') {

  }
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
}

export default {
  name: 'WebsiteGoodsGatherEdit',
  components: {
    // SimpleUploader,
    // DictSelect,
  },
  props: {
    orderId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  methods: {
    onCancel,
    toPayInfo,
  },
  data() {
    return {
      payment: '',
      form: {
        data: {
          payment: '',
          payUrl: '',
        },
        title: '',
        rules: {
        },
      },
    };
  },
  async created() {
  },
};
</script>
